import AppStore from '@/stores/AppStore.js'
import FingerprintStore from '@/stores/FingerprintStore.js'
import AnalyticsStore from '@/stores/AnalyticsStore.js'
import ApiStore from '@/stores/ApiStore.js'
import AuthStore from '@/stores/AuthStore.js'
import { WalletStore } from '@/stores/WalletStore.js'
import AffiliateStore from '@/stores/AffiliateStore.js'
import ThemeStore from '@/stores/ThemeStore.js'
import RouterStore from '@/stores/RouterStore.js'
import SeoStore from '@/stores/SeoStore.js'
import NotificationsStore from '@/stores/NotificationsStore.js'
import ResponsiveStore from '@/stores/ResponsiveStore.js'
import TimeStore from '@/stores/TimeStore.js'
import ExchangeStore from '@/stores/ExchangeStore.js'
import MessagesStore from '@/stores/MessagesStore.js'
import JitsiStore from '@/stores/jitsi/JitsiStore.js'
import UploadsStore from '@/stores/UploadsStore.js'

export const PERSISTABLE_CONFIG = {
  removeOnExpiration: true,
  storage: localStorage,
}

export const PERSISTABLE_REACTION_CONFIG = {
  fireImmediately: false,
}

export const STORES = Object.entries({
  affiliateStore: AffiliateStore,
  analyticsStore: AnalyticsStore,
  apiStore: ApiStore,
  appStore: AppStore,
  authStore: AuthStore,
  exchangeStore: ExchangeStore,
  fingerprintStore: FingerprintStore,
  jitsiStore: JitsiStore,
  messagesStore: MessagesStore,
  notificationsStore: NotificationsStore,
  responsiveStore: ResponsiveStore,
  routerStore: RouterStore,
  seoStore: SeoStore,
  // sseStore: SseStore,
  themeStore: ThemeStore,
  timeStore: TimeStore,
  uploadsStore: UploadsStore,
  walletStore: WalletStore,
})
